import PropTypes from 'prop-types';

import { Button } from '@hivebrite/design-system/Button';

const CommitPayLaterButton = ({ disabled = false, onClick, payNowEnabled }) => {
  let variant = 'primary';

  if (payNowEnabled) {
    variant = 'secondary';
  }

  return (
    <div className="text--center">
      <Button
        id="commit-pay-later"
        dataTestId="donations-commit-pay-later-submit"
        isDisabled={disabled}
        onClick={onClick}
        variant={variant}
      >
        {s__('Donations|Commit - Pay Later')}
      </Button>
    </div>
  );
};

CommitPayLaterButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  payNowEnabled: PropTypes.bool,
};

export default CommitPayLaterButton;
